/**
 * Created by mauget on 10/29/16.
 */

import $ from 'jquery';

//===========================================================================================
// Manages asynchronous loading of a configuration file that lives in the web root directory
// outside the bundle.js file. An administrator can modify the "assets/pfconfig.json" file to
// alter aspects of the application outside of the build operation.
//
// Note that we return a promise due to the asychronous nature of reading this late-bound
// file at run-time.
//
// Caller would call "configService.promise.then( myCallBackFn )" to synchronise to the
// JSON result sent to the callback's parameter.
//
// Example:
//
//    configService.promise.then( config => {
//        this.apiHostUrl = config.apiHostUrl;
//        this.hostUrl = config.hostUrl;
//    } );
//
//===========================================================================================
class ConfigService {

    constructor() {

        this._promise = new Promise((resolve, reject) => {

            // Require relative path to late-bound copy of assets/pfconfig.json copied to root ./pfconfig.json
            const pfconfig = require('./../../pfconfig.json');

            // Load the root's copy of pfconfig.json file asynchronously
            $.getJSON(pfconfig, data => resolve(data));
        });
    }

    get promise() {
        return this._promise;
    }

}

const configService = new ConfigService();
export default configService;
